export default "__VITE_ASSET__BMs0Ywtn__"